import UseIcon from "assets/point_assets/use.svg";
import AddIcon from "assets/point_assets/add.svg";
import { formatNumberWithCommas } from "util/function/function";
import { format, parse } from "date-fns";

const PointHistoryItem = ({ item }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          background: "#ffffff",
          padding: "24px",
          boxSizing: "border-box",
          borderRadius: "16px",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
          }}
        >
          {(item?.addPoint || item?.payPoint) && (
            <img
              src={AddIcon}
              alt="use"
              style={{ width: "40px", height: "40px" }}
            />
          )}
          {item?.usePoint && (
            <img
              src={UseIcon}
              alt="use"
              style={{ width: "40px", height: "40px" }}
            />
          )}
          <div
            style={{
              display: "flex",
              gap: "2px",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <div className="f16_374151_W400">
              {item?.payPoint && "포인트 결제"}
              {item?.addPoint && "포인트 적립"}
              {item?.usePoint && "매칭 포인트"}
            </div>
            <div className="f16_6B7280_W400">{format(new Date(item.createDate), 'yyyy-MM-dd HH:mm:ss')}</div>
          </div>
        </div>
        <div className={item?.usePoint ? "f16_EF4444_W500" : "f16_3B82F6_W500"}>
          {item?.usePoint && `-${formatNumberWithCommas(item?.usePoint)}P`}
          {item?.addPoint && `+${formatNumberWithCommas(item?.addPoint)}P`}
          {item?.payPoint && `+${formatNumberWithCommas(item?.payPoint)}P`}
        </div>
      </div>
    </>
  );
};

export default PointHistoryItem;
